import { useCallback, useEffect, useState } from "react";
import {
  IEmailConfigurationData,
  IEmailConfigurationIndex,
} from "../../../../../models/master/email";
import { connect, useDispatch } from "react-redux";
import {
  alertConstants,
  getAlertData,
} from "../../../../../helper/sweet-alert";
import { setEmailConfigurations } from "../../../../../store/slices/master/emailConfigurationSlice";
import {
  deleteEmailConfiguration,
  getEmailConfiguration,
  getEmailConfigurations,
} from "../../../../../action/masters/emailConfigurationActionCreator";
import LoaderSpinner from "../../../../../common-components/loader";
import ReactModal from "react-modal";
import EmailConfigurationCreate from "./emailConfigurationCreate";
import EmailConfigurationEdit from "./emailConfigurationEdit";
import SweetAlert from "react-bootstrap-sweetalert";
import { getColleges } from "../../../../../action/common/commonActionCreator";
import FloatingLabelDropDown from "../../../../../common-components/floatingdropdown";
import { sortAlphabetically } from "../../../../../common-functions/commonFunctions";
import { UserRole } from "../../../../../constants/RoleEnum";

const EmailConfigurationIndex = (props: IEmailConfigurationIndex) => {
  const {
    getEmailConfigurations,
    emailConfiguration,
    getEmailConfiguration,
    emailConfigurations,
    deleteEmailConfiguration,
    getColleges,
    colleges,
  } = props;

  const [showCreate, setShowCreate] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [isDelete, setIsDelete] = useState<boolean>(false);
  const [itemToDelete, setItemToDelete] = useState<number>(0);
  const [showAlert, setShowAlert] = useState<boolean>(false);
  const [alertType, setAlertType] = useState<any>("success");
  const [alertTitle, setAlertTitle] = useState<string>("Default");
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isEditLoading, setIsEditLoading] = useState<boolean>(false);
  const [selectedCollege, setSelectedCollege] = useState<number | null>(null);
  const dispatch = useDispatch();

  const handleCreateOpen = () => setShowCreate(true);
  const handleCreateClose = () => setShowCreate(false);
  const handleEditOpen = () => setShowEdit(true);
  const handleEditClose = () => setShowEdit(false);

  const editItem = async (id: number) => {
    handleEditOpen();
    setIsEditLoading(true);
    try {
      await getEmailConfiguration(id);
    } finally {
      setIsEditLoading(false);
    }
  };

  // executes when delete button is clicked
  const deleteItem = (id: number) => {
    setIsDelete(true);
    setAlert(alertConstants.inactiveCheck);
    setItemToDelete(id);
  };

  const onConfirm = () => {
    if (alertType === alertConstants.error) {
      setShowAlert(false);
    } else if (isDelete === true) {
      setShowAlert(false);
      setIsDelete(false);
      deleteEmailConfiguration(itemToDelete, setAlert);
    } else {
      setShowAlert(false);
      setIsDelete(false);
      getAllEmailConfigurations(selectedCollege ?? undefined);
    }
  };

  const setAlert = (type: string) => {
    let alertData = getAlertData(type);
    if (alertData) {
      setShowAlert(true);
      setAlertType(alertData.type);
      setAlertTitle(alertData.title);
    }
  };

  const getAllEmailConfigurations = async (collegeId?: number) => {
    setIsLoading(true);
    try {
      await getEmailConfigurations(collegeId);
    } finally {
      setIsLoading(false);
    }
  };

  const onSelectionChange = useCallback((e: any) => {
    if (e.target.name === "college") {
      setSelectedCollege(e.target.value);
    }
    getEmailConfigurations(e.target.value);
  }, []);

  useEffect(() => {
    getAllEmailConfigurations();
    getColleges();
    return () => {
      dispatch(setEmailConfigurations([]));
    };
  }, []);

  return (
    <>
      <div className="admincontent">
        <div className="title">
          <h2>Email Configuration</h2>
          <div className="side-filter">
            <div className="justify-content-left">
              <FloatingLabelDropDown
                label=""
                placeholder="-Select University Management-"
                onChange={(e: any) => onSelectionChange(e)}
                isMandatory={false}
                value={selectedCollege}
                name="college"
                optionsList={sortAlphabetically(colleges)}
              />
            </div>
            <a
              href="javascript:void(0)"
              className="btn btn-primary"
              onClick={() => {
                handleCreateOpen();
              }}
            >
              <img src="/assets/images/icon/plus.svg" alt="" className="me-2" />
              Add New
            </a>
          </div>
        </div>
        <ul className="d-flex gap-3 flex-wrap mt-3">
          {isLoading ? (
            <LoaderSpinner />
          ) : emailConfigurations && emailConfigurations.length > 0 ? (
            emailConfigurations?.map(
              (emailConfigurationData: IEmailConfigurationData) => {
                return (
                  <li
                    className="admin-card"
                    style={{
                      pointerEvents: !emailConfigurationData.isActive
                        ? "none"
                        : "auto",
                      opacity: !emailConfigurationData.isActive ? 0.5 : 1,
                    }}
                  >
                    <div className="top">
                      <div className="btn-flex">
                        <button
                          className="btn-edit"
                          onClick={() =>
                            editItem(emailConfigurationData.id ?? 0)
                          }
                        >
                          <img src="/assets/images/icon/edit-wh.svg" alt="" />
                        </button>
                        {/* <button
                          className="btn-delete"
                          onClick={() => deleteItem(emailConfigurationData.id ?? 0)}
                          disabled={true}>
                          <img src="/assets/images/icon/trash-wh.svg" alt="" />
                        </button> */}
                      </div>
                    </div>
                    <div className="btm">
                      <h2>{emailConfigurationData.emailBlock}</h2>
                      <p>
                        {emailConfigurationData?.userType
                          ?.map((type: number) => UserRole[type])
                          .join(", ")}
                      </p>
                    </div>
                  </li>
                );
              }
            )
          ) : (
            <p>No Records Found</p>
          )}
        </ul>
      </div>
      <ReactModal
        isOpen={showCreate}
        onRequestClose={handleCreateClose}
        className="react-modal-content"
        overlayClassName="react-modal-overlay"
        shouldCloseOnOverlayClick={false}
      >
        <EmailConfigurationCreate
          setShowCreate={handleCreateClose}
          getEmailConfigurations={() => getEmailConfigurations(selectedCollege ?? undefined)}
        />
      </ReactModal>

      {isEditLoading ? (
        <LoaderSpinner />
      ) : (
        <ReactModal
          isOpen={showEdit}
          onRequestClose={handleEditClose}
          className="react-modal-content"
          overlayClassName="react-modal-overlay"
          shouldCloseOnOverlayClick={false}
        >
          <EmailConfigurationEdit
            setShowEdit={handleEditClose}
            emailConfiguration={emailConfiguration}
            getEmailConfigurations={() => getEmailConfigurations(selectedCollege ?? undefined)}
          />
        </ReactModal>
      )}
      <SweetAlert
        show={showAlert}
        success={false}
        type={alertType}
        title={alertTitle}
        onConfirm={() => onConfirm()}
        showCancel={isDelete}
        onCancel={() => {
          setShowAlert(false);
          setIsDelete(false);
        }}
        cancelBtnText={"No"}
        confirmBtnText={isDelete ? "Yes" : "Ok"}
      />
    </>
  );
};

const mapDispatchToProps = {
  getEmailConfigurations: (collegeId?: number) =>
    getEmailConfigurations(collegeId),
  getEmailConfiguration: (id: number) => getEmailConfiguration(id),
  deleteEmailConfiguration: (id: number, callBack: Function) =>
    deleteEmailConfiguration(id, callBack),
  getColleges: () => getColleges(),
};

function mapStateToProps(state: any) {
  return {
    emailConfigurations: state.emailConfiguration.emailConfigurations,
    emailConfiguration: state.emailConfiguration.emailConfiguration,
    colleges: state.common.colleges,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EmailConfigurationIndex);
